import { createFileRoute } from '@tanstack/react-router';

// テスト結果詳細(明細 1 件・読み取り専用の独立詳細)。
// test-sets の _layout の外に置くことで、テストセットのタブ/ヘッダーを継承しない。
// 履歴は持たず、最新結果スナップショット + executionLog のみを表示する。
// search パラメータは不要なため validateSearch なし。
// コンポーネントは index.lazy.tsx 側で遅延ロードして bundle 分割する。
export const Route = createFileRoute('/_stacktrace/test-sets/$id/$detailId/')({});